// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"258b012d","455":"fbd4f82e","977":"fa8bdf19"}[chunkId] + ".chunk.js";
};